import { types as sdkTypes } from '../../../util/sdkLoader';

const { LatLng } = sdkTypes;

/** Locale-independent URL value for current-location pickup searches. */
export const CURRENT_LOCATION_URL_VALUE = '__current__';

export const parsePickupOrigin = str => {
  if (!str) return null;
  const parts = `${str}`.split(',');
  if (parts.length !== 2) return null;
  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);
  return isNaN(lat) || isNaN(lng) ? null : new LatLng(lat, lng);
};

export const isCurrentLocationPlace = selectedPlace =>
  !!(selectedPlace?.origin && !selectedPlace?.address);

export const isCurrentLocationUrlValue = (pickupAddress, currentLocationLabel) =>
  pickupAddress === CURRENT_LOCATION_URL_VALUE || pickupAddress === currentLocationLabel;

export const isCurrentLocationFromParams = (pickupAddress, pickupOrigin, currentLocationLabel) =>
  !!pickupOrigin &&
  (isCurrentLocationUrlValue(pickupAddress, currentLocationLabel) || !pickupAddress);

export const pickupAddressForSubmit = (selectedPlace, search) => {
  if (isCurrentLocationPlace(selectedPlace)) {
    return CURRENT_LOCATION_URL_VALUE;
  }
  return search;
};

export const buildLocationStateFromUrl = (
  urlQueryParams = {},
  currentLocationLabel,
  defaultRadius
) => {
  const pickupAddress = urlQueryParams.pickupAddress || '';
  const pickupRadius = urlQueryParams.pickupRadius
    ? parseInt(urlQueryParams.pickupRadius, 10)
    : defaultRadius;
  const origin = parsePickupOrigin(urlQueryParams.pickupOrigin);
  const isCurrentLocation = isCurrentLocationFromParams(
    pickupAddress,
    urlQueryParams.pickupOrigin,
    currentLocationLabel
  );

  return {
    locationValue: {
      search: isCurrentLocation ? '' : pickupAddress,
      predictions: [],
      selectedPlace: origin
        ? {
            address: isCurrentLocation ? '' : pickupAddress,
            origin,
            bounds: null,
          }
        : null,
    },
    radius: pickupRadius,
    isCurrentLocation,
    locationError: null,
  };
};
